import { FaCode, FaMobileScreen, FaPalette, FaBolt } from 'react-icons/fa6';

const whyChooseUs = {
  heading: "High-Quality Website Templates",
  sub: "Why Choose Us",
  content:
    "We create modern HTML and React templates designed for performance, usability, and clean design — helping you launch faster and build better websites with ease.",

  points: [
    {
      id: 1,
      icon: <FaCode />,
      title: 'Clean Code',
      description: 'Well-structured and easy-to-understand code for smooth customization.'
    },
    {
      id: 2,
      icon: <FaMobileScreen />,
      title: 'Fully Responsive',
      description: 'Templates that look perfect on all devices, from mobile to desktop.'
    },
    {
      id: 3,
      icon: <FaPalette />,
      title: 'Modern Design',
      description: 'Stylish and user-friendly layouts based on latest design trends.'
    },
    {
      id: 4,
      icon: <FaBolt />,
      title: 'Fast Performance',
      description: 'Optimized for speed to ensure a smooth and fast user experience.'
    },
  ]
};

export default whyChooseUs;